<template>
    <df-app no-padding title="MyAssessments">
        <template slot="aside" v-if="rows">
            <!--
            <span class="title text-uppercase">Digital.Check</span>
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('leads', 'primary')"/>
            </ul>

            <div class="aside-compose">
                <router-link :to="{ name: 'create-customer' }" class="btn btn-lg btn-primary btn-block">Einladung versenden</router-link>
            </div>
            -->

            <span class="title text-uppercase">Digital.Assessment</span>
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('assessments', 'danger')"/>
                <component :is="navItem('reports', 'warning')"/>
            </ul>

            <span class="title text-uppercase">Digital.Report</span>
            <ul class="nav nav-pills nav-stacked">
                <component :is="navItem('archived', 'success')"/>
            </ul>
        </template>

        <router-view :rows="filteredRows" :title="title" :icon="icon" @reload="load" @update="update" v-if="rows"/>
    </df-app>
</template>

<script>
    import admin from '../../../mixins/admin';
    import Assessment from '../../../models/Assessment';

    export default {
        mixins: [admin],

        data: () => ({
            Model: Assessment,

            route: 'admin-assessments',
            filters: {
                default: { title: 'Alle Assessments', icon: 'assignment', filter: () => true },
                leads: { title: 'Offene Einladungen', icon: 'assignment-o', filter: a => a.stateLead },
                assessments: { title: 'Neue Assessments', icon: 'assignment-alert', filter: a => a.stateAssessment },
                reports: { title: 'Report erstellen', icon: 'assignment', filter: a => a.stateReport },
                archived: { title: 'Archivierte Assessments', icon: 'archive', filter: a => a.stateArchived },
            },
        }),
    };
</script>
